<div class='modal-header d-flex justify-content-between p-2'>
  <h3>Nota: </h3>
  <!-- Mostrar botón con fa-plus si notaDeCuenta es vacío o null -->
  <button ngbTooltip="Agregar nota." *ngIf="TextAreaOculto" class="btn btn-primary btn-sm" (click)="campoEditable()">
    <i class="fa fa-plus"></i>
  </button>

  <!-- Mostrar botón con fa-edit si notaDeCuenta tiene algún valor -->
  <button ngbTooltip="Editar nota." *ngIf="TextAreaNoVacio" class="btn btn-primary btn-sm" (click)="campoEditable()">
    <i class="fa fa-edit fa-lg" aria-hidden="true"></i>
  </button>
</div>
<div class='modal-body'>
    <div class="spinner-container" *ngIf="cargando">
          <ngx-spinner name="spinnerGrafico" bdOpacity=0.3bd Color="rgba(193,193,193,0)" size="medium" color="#185db5"
                 type="ball-grid-beat" [fullScreen]="false">
                <p style="color: white"> C a r g a n d o . . . </p>
          </ngx-spinner>
    </div>
    <div [formGroup]="miFormulario" *ngIf="!cargando && !TextAreaOculto">
      <div class="col-12">
        <textarea id="mensaje" class="form-control" placeholder="Nota de cuenta" formControlName="mensajeFormControl" maxlength="255" rows='12' (input)="onTextareaInput()"></textarea>
      </div>
    </div>
    <div *ngIf="TextAreaOculto" class="col-md-12 alert alert-warning">No hay una nota configurada</div>
</div>
<div class="modal-footer">
  <button class="btn btn-primary" [disabled]="cargando || !notaDeCuenta?.trim()" (click)="guardarCambios()">Guardar</button>
  <button class="btn btn-secondary" [disabled]="cargando" (click)="cancelar()">Cancelar</button>
</div>
